'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n        height: ', ' + "px";\n        background-color: ', ';\n        border: ', ';\n        border-color: ', ';\n        border-radius: ', ';\n        display: ', ';\n        padding: ', ';\n        padding-right: ', ';\n        color: ', '; \n        cursor: ', ';\n        font-size: ', ';\n        font-weight: 500;\n        letter-spacing: ', ';\n        min-width: 100px;\n        text-transform: ', ';\n        transition: background-color 400ms ease;\n        width: ', ';\n        \n        &:hover {\n            background-color: ', ';\n            color: ', ';\n        }\n    '], ['\n        height: ', ' + "px";\n        background-color: ', ';\n        border: ', ';\n        border-color: ', ';\n        border-radius: ', ';\n        display: ', ';\n        padding: ', ';\n        padding-right: ', ';\n        color: ', '; \n        cursor: ', ';\n        font-size: ', ';\n        font-weight: 500;\n        letter-spacing: ', ';\n        min-width: 100px;\n        text-transform: ', ';\n        transition: background-color 400ms ease;\n        width: ', ';\n        \n        &:hover {\n            background-color: ', ';\n            color: ', ';\n        }\n    ']),
    _templateObject2 = _taggedTemplateLiteral(['\n        margin-right: 14px;\n    '], ['\n        margin-right: 14px;\n    ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FavoritingHeart = require('../Favoriting/FavoritingHeart');

var _FavoritingHeart2 = _interopRequireDefault(_FavoritingHeart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Button = function Button(_ref) {
    var size = _ref.size,
        textColor = _ref.textColor,
        textColorHover = _ref.textColorHover,
        backgroundColor = _ref.backgroundColor,
        backgroundColorHover = _ref.backgroundColorHover,
        buttonClass = _ref.buttonClass,
        buttonText = _ref.buttonText,
        hasBorder = _ref.hasBorder,
        borderColor = _ref.borderColor,
        onButtonClick = _ref.onButtonClick,
        fillSpace = _ref.fillSpace,
        isPillShaped = _ref.isPillShaped,
        isFavoritingButton = _ref.isFavoritingButton,
        isItemFavorited = _ref.isItemFavorited,
        disabled = _ref.disabled;


    var buttonHeight = void 0,
        padding = void 0,
        fontSize = void 0;

    if (size === 'small') {
        buttonHeight = '32';
        padding = '5px 10px 6px 10px';
        fontSize = "12px";
    }

    if (size === 'medium') {
        buttonHeight = '42';
        padding = '6px 10px 9px 10px';
        fontSize = "17px";
    }

    if (size === 'large') {
        buttonHeight = '51';
        padding = '11px 10px 13px 10px';
        fontSize = "17px";
    }

    var CustomButton = _styledComponents2.default.button(_templateObject, buttonHeight, backgroundColor ? backgroundColor : "#fff", hasBorder ? 'solid 1px' : '0', borderColor ? borderColor : "#ccc", isPillShaped ? buttonHeight / 2 + "px" : '2px', isFavoritingButton ? "flex" : "block", padding, isFavoritingButton ? '24px' : null, textColor ? textColor : "#fff", disabled ? 'not-allowed' : 'pointer', fontSize, size === "small" ? "2.5px" : "normal", size === "small" ? "uppercase" : "none", fillSpace ? '100%' : 'auto', backgroundColorHover ? backgroundColorHover : "#ddd", textColorHover);

    var FavoritingHeartContainer = _styledComponents2.default.div(_templateObject2);

    return _react2.default.createElement(
        CustomButton,
        {
            className: buttonClass,
            onClick: onButtonClick,
            disabled: disabled
        },
        isFavoritingButton ? _react2.default.createElement(
            FavoritingHeartContainer,
            null,
            _react2.default.createElement(_FavoritingHeart2.default, {
                isFavorited: isItemFavorited,
                padding: '3px'
            })
        ) : null,
        _react2.default.createElement(
            'span',
            { className: 'button-text' },
            buttonText
        )
    );
};

exports.default = Button;


//////////////////
// WEBPACK FOOTER
// ./~/pubweb-react-components/dist/components/Buttons/Button.js
// module id = 204
// module chunks = 168707334958949